<template>
  <v-layout>
    <v-dialog v-model="dialog" max-width="450">
      <v-card class="py-3">
        <v-card-title class="headline"> Finalizar Turno </v-card-title>
        <v-card-text class="subtitle-1">
          Selecciono al Coordinador de Cabina:
          <span class="font-weight-medium"
            >"{{
              selectedHistorial != null ? selectedHistorial.usuario : ""
            }}"</span
          >, con la extensión:
          <span class="font-weight-medium"
            >"
            {{
              selectedHistorial != null ? selectedHistorial.extension : ""
            }}".</span
          >
        </v-card-text>
        <v-card-actions class="px-6">
          <v-btn color="primary" outlined @click="limpiar"> Cancelar </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="cerrarTurnoAdmin"> Aceptar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-flex class="px-10 py-5">
      <v-data-table
        :headers="headers"
        :items="historial"
        :loading="loader"
        loading-text="Listando Datos..."
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-container class="px-5 py-4">
            <v-layout>
              <h2 class="py-2 pl-3">
                Historial de Extensiones - Coordinador Cabina
              </h2>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row class="mt-6 mb-4">
              <v-flex xs12 sm12 md3 class="px-2">
                <v-text-field
                  class="text-xs-center"
                  v-model="search"
                  append-icon="search"
                  label="Búsqueda"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-spacer></v-spacer>

              <v-flex xs12 sm12 md2 class="px-2">
                <v-text-field
                  v-model="fechaInicio"
                  type="date"
                  hide-details
                  label="Inicio"
                  :max="new Date().toISOString().substr(0, 10)"
                  clearable
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md2 class="px-2">
                <v-text-field
                  v-model="fechaFin"
                  type="date"
                  hide-details
                  label="Fin"
                  :max="new Date().toISOString().substr(0, 10)"
                  clearable
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md1 class="text-center pt-3" align-self-center>
                <v-btn color="blue" dark @click="listarHistorial" block>
                  Listar
                </v-btn>
              </v-flex>
              <v-flex xs12 sm12 md1 class="text-center pt-3" align-self-center>
                <v-btn
                  color="green"
                  :block="$vuetify.breakpoint.smAndDown"
                  dark
                  @click="formatReporte"
                >
                  <v-icon class="ml-2">fas fa-file-excel</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider></v-divider>
        </template>

        <template v-slot:[`item.usuario`]="{ item }">
          {{ item.usuario.toLocaleUpperCase() }}
        </template>
        <template v-slot:[`item.fechaInicio`]="{ item }">
          {{ formatDate(item.fechaInicio) }}
        </template>
        <template v-slot:[`item.fechaFin`]="{ item }">
          {{ formatDate(item.fechaFin) }}
        </template>
        <template v-slot:[`item.horaFin`]="{ item }">
          {{ item.horaFin == null ? "- - - -" : item.horaFin }}
        </template>
        <template v-slot:[`item.estado`]="{ item }">
          <v-chip :color="item.estado ? 'green' : 'red'" dark>
            {{ item.estado ? "Activo" : "Finalizado" }}
          </v-chip>
        </template>
        <template v-slot:[`item.opciones`]="{ item }">
          <v-tooltip top color="red">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                color="red"
                :disabled="!item.estado"
                @click="confirmarFinalizarTurno(item)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>fa fa-times</v-icon>
              </v-btn>
            </template>
            <span>Finalizar Turno</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import XLSX from "xlsx";

export default {
  data() {
    return {
      text: "Historial Gruas",
      search: "",
      loader: false,
      dialog: false,
      selectedHistorial: null,
      fechaInicio: new Date().toISOString().substr(0, 10),
      fechaFin: new Date().toISOString().substr(0, 10),
      historial: [],
      headers: [
        {
          text: "Id",
          value: "id",
          sortable: false,
          width: 100,
          align: "center",
        },
        {
          text: "Usuario",
          value: "usuario",
          sortable: true,
          align: "center",
          width: 250,
        },
        {
          text: "Extensión",
          value: "extension",
          sortable: true,
          align: "center",
          width: 100,
        },
        {
          text: "Nombre Extensión",
          value: "extensionNombre",
          sortable: true,
          align: "center",
          width: 150,
        },
        {
          text: "Fecha Inicio",
          value: "fechaInicio",
          sortable: true,
          align: "center",
          width: 120,
        },
        {
          text: "Hora Inicio",
          value: "horaInicio",
          sortable: true,
          align: "center",
          width: 120,
        },
        {
          text: "Fecha Fin",
          value: "fechaFin",
          sortable: true,
          align: "center",
          width: 120,
        },
        {
          text: "Hora Fin",
          value: "horaFin",
          sortable: true,
          align: "center",
          width: 120,
        },
        {
          text: "Estado",
          value: "estado",
          sortable: true,
          align: "center",
          width: 100,
        },
        {
          text: "Opciones",
          value: "opciones",
          sortable: false,
          align: "center",
          width: 100,
        },
      ],
    };
  },
  created() {
    const today = new Date();
    const firstDayInMonth = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 5
    );
    this.fechaInicio = firstDayInMonth.toISOString().substring(0, 10);

    this.listarHistorial();
  },
  computed: {
    mensajeBienvenida() {
      return (
        `Bienvenido/a, ${this.$store.state.usuario.nombre}!` || `Bienvenido/a!`
      );
    },
  },
  methods: {
    confirmarFinalizarTurno(item) {
      this.dialog = true;
      this.selectedHistorial = item;
    },
    limpiar() {
      this.selectedHistorial = null;
      this.dialog = false;
    },
    cerrarTurnoAdmin() {
      if (this.selectedHistorial == null) return;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .put(
          `api/HistorialOperadoresCabina/${this.selectedHistorial.usuarioId}`,
          {},
          configuracion
        )
        .then(() => {
          this.listarHistorial();
          this.limpiar();
        })
        .catch((err) => console.error(err));
    },
    ExportarExcel(listado) {
      let data = XLSX.utils.json_to_sheet(listado);
      const workbook = XLSX.utils.book_new();
      const filename = `Operadores Cabina ${this.fechaInicio.toString(
        "yyyy-MM-dd"
      )} a ${this.fechaFin.toString("yyyy-MM-dd")}`;

      data["!cols"] = [
        { wch: 9 },
        { wch: 16 },
        { wch: 30 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 9 },
      ];
      XLSX.utils.book_append_sheet(workbook, data, "Historial");
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    formatReporte() {
      const formatDate = (date) => {
        if (!date) return "";
        return new Date(date).toISOString().split("T")[0];
      };

      const listadoHistorial = this.historial.map((data) => {
        const historial = {
          Extensión: data.extension,
          "Nombre Extensión": data.extensionNombre,
          USUARIO: data.usuario.toLocaleUpperCase(),
          "Fecha Inicio": formatDate(data.fechaInicio),
          "Hora Inicio": data.horaInicio,
          "Fecha Fin": formatDate(data.fechaFin),
          "Hora Fin": data.horaFin,
          Estado: data.estado ? "Activo" : "Finalizado",
        };

        delete historial.id;
        delete historial.proveedorId;
        delete historial.operadorGruaId;

        return historial;
      });

      this.ExportarExcel(listadoHistorial);
    },
    listarHistorial() {
      this.loader = true;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          `api/HistorialOperadoresCabina?fechaInicio=${this.fechaInicio}&fechaFin=${this.fechaFin}`,
          configuracion
        )
        .then((res) => {
          this.historial = res.data;
        })
        .catch((err) => console.error(err))
        .finally(() => (this.loader = false));
    },
    formatDate(fecha) {
      if (fecha == null) return "- - - -";
      if (!fecha || typeof fecha != "string") {
        throw new Error(
          "El parametro 'fecha' debe ser de tipo String y no puede estar vacio"
        );
      }

      return moment(fecha).format("YYYY-MM-DD");
    },
  },
};
</script>